// extracted by mini-css-extract-plugin
export default {"countdown":"TimeLeft_countdown__ebJF6","countdownExpired":"TimeLeft_countdownExpired__wiUkU","position":"TimeLeft_position__Vv5Dn"};